
// Change option selected for age group 
const label = document.querySelector('.dropdown__filter-selected');
const options = Array.from(document.querySelectorAll('.dropdown__select-option'));
let isSelected = false;
options.forEach((option) => {
    option.addEventListener('click', () => {
        let errorMessageContent = document.querySelector('.size-calculator-error-message');
        label.textContent = option.textContent;
        isSelected = true;
        errorMessageContent.classList.add('hidden')
    });
});

// Button click event
const button = document.querySelector('.age-group-button ');
button.addEventListener('click', (e) => {
    e.preventDefault();
    if (!isSelected) {
        document.querySelector('.size-calculator-error-message').textContent = 'Please select an option from the dropdown.';
    } else {
        // Redirect to another page or perform other actions
        const userSelectedAge = label.textContent;
        sessionStorage.setItem('userselectedage', userSelectedAge);
        window.location.href = '/pages/bra-cup-fitting';
    }
});

// Close dropdown onclick outside
document.addEventListener('click', (e) => {
    const toggle = document.querySelector('.dropdown__switch');
    const element = e.target;
    if (element == toggle) return;
    const isDropdownChild = element.closest('.dropdown__filter');
    if (!isDropdownChild) {
        toggle.checked = false;
        isSelected = false;
    }
});

